<ng-template #recursiveList let-dataList let-dragOverId="dragOverId" let-level="level">
  <div class="accordion" [ngClass]="viewType==='reorder-taxonomy'?'tree':''"
    *ngFor="let item of dataList;let index= index;trackBy : trackById">

    <div [class.dim]="modalTriggerLocation==='project' ? item.project_enabled ===0 : null"
      class="cards-header d-flex align-items-start p-0" id="{{item.id}}${{item.parent_id}}"
      [ngClass]="viewType==='reorder-taxonomy'?'card-header':''">

      <div class="col px-2 item" [ngClass]="item.children.length > 0 ? 'pt-1' : 'pt-2'"
        id="{{item.id}}${{item.parent_id}}">

        <!-- for the taxonomy builder reorder -->
        <div class="row mx-0 tr justify-content-between" role="row"
          [ngClass]="[copyPasteFlag===0 ? 'active':'', copyPasteFlag===1 && item.cut===1 ? 'cut':'']">
          <div class="col-12 p-0 d-flex" id="{{item.id}}${{item.parent_id}}" *ngIf="viewType==='reorder-taxonomy'">

            <div class="col-auto p-1" *ngIf="item.children.length>0">
              <button *ngIf="item?.children && item?.children.length > 0" class="btn btn-toggle" [ngClass]="[item.expand?'':'collapsed']"
                id="{{item.id}}${{item.parent_id}}-expandIcon" (click)="item.expand = !item.expand"
                [attr.aria-label]="('click to ' + (item.expand ? 'collapse ' : 'expand ') + 'node- ' + item?.human_coding_scheme + ' ' + item?.full_statement)">
              </button>
            </div>
            <span *ngIf="item && item.children && item.children.length === 0" [ngClass]="[item.expand?'':'collapsed', showBullet(item)?'last-node':'']"
              class="float-left pl-0" id="{{item.id}}${{item.parent_id}}-expandIcon">
            </span>

            <div class="col pl-0" [ngClass]="item.children.length===0?'card-body--last':'card-link'">
              <ng-container *ngIf="item.children.length===0">
                <h3 *ngIf="item.is_document!==1" class="item-name font-2x text-wrapped font-bold mb-1 drag-title">
                  {{item.human_coding_scheme }}{{item.human_coding_scheme?':':''}}{{item.full_statement
                  | slice:0:200}}{{item.full_statement.length>200?'...':''}}</h3>
                <h3 *ngIf="item.is_document===1" class="item-name font-2x text-wrapped font-bold mb-1 drag-title">
                  {{item.document_title?item.document_title:item.title}}</h3>
              </ng-container>
              <ng-container *ngIf="item.children.length>0">
                <h2 *ngIf="item.is_document!==1" class="item-name font-2x text-wrapped font-bold mb-1 drag-title">
                  {{item.human_coding_scheme}}{{item.human_coding_scheme?':':''}}{{item.full_statement
                  | slice:0:200}}{{item.full_statement.length>200?'...':''}}</h2>
                <h2 *ngIf="item.is_document===1" class="item-name font-2x text-wrapped font-bold mb-1 drag-title">
                  {{item.document_title?item.document_title:item.title}}</h2>
              </ng-container>
            </div>

            <div class="col-auto p-0 align-self-end">
              <p class="item-type font-0x font-bold text-right text-uppercase mb-0"> {{item.node_type}}</p>

              <!-- cut-paste and reorder buttons START -->

              <div class="col-12 d-flex p-0" *ngIf="!item.isOrphanLabel">

                <div class="col p-0 text-right">
                  <button type="button" class="btn btn-clear p-1"
                    *ngIf="copyPasteFlag===1 && selectedNodeId !== item.id && item.cut===0 && (modalTriggerLocation==='project' ? item.project_enabled !== 0: true)"
                    (click)="copyPasteFlag = 0;pasteTargetElement(item);" title="Paste node">
                    <em class="material-icons-outlined font-4x" aria-hidden="true">content_paste</em> </button>

                  <ng-container
                    *ngIf="item.is_document !== 1 && (item.id !== firstNode.id) && (modalTriggerLocation==='project' ? item.project_enabled !== 0: true)">
                    <button type="button" class="btn btn-clear p-1" *ngIf="copyPasteFlag===0"
                      (click)="copyPasteFlag = 1;selectedNodeId = item.id;copySourceElement(item,dataList);"
                      title="Cut node">
                      <em class="material-icons-outlined font-4x" aria-hidden="true">content_cut</em> </button>

                    <button type="button" class="btn btn-clear p-1" (click)="reOrderSiblings(dataList, -1, item.id);"
                      *ngIf="dataList.length !== 1 && index !== 0" title="Move upward">
                      <em class="material-icons-outlined font-4x" aria-hidden="true">arrow_upward</em>
                    </button>

                    <button type="button" class="btn btn-clear p-1" (click)="reOrderSiblings(dataList, +1, item.id);"
                      *ngIf="(dataList.length !== (index + 1)) && dataList.length !== 1" title="Move downward">
                      <em class="material-icons-outlined font-4x" aria-hidden="true">arrow_downward</em> </button>
                  </ng-container>
                </div>
              </div>
              <!-- cut-paste and reorder buttons END -->
            </div>

          </div>
        </div>
        <!-- for the taxonomy builder reorder end -->

        <ng-container *ngIf="viewType!=='reorder-taxonomy'">
          <p class="item-type font-0x font-bold text-uppercase mb-0" id="{{item.id}}">
            {{item.item_type==='Container'.toLowerCase()?item.node_type:item.item_type}}</p>

          <button type="button" id="{{item.id}}"
            class="item-name font-2x text-wrapped text-left font-bold btn btn-clear p-0 btn-block mb-1"
            *ngIf="(item.item_type!=='Container'.toLowerCase())"
            (click)="onItemClick(item)">{{item.human_coding_scheme}}:{{item.full_statement
            | slice:0:200}}{{item.full_statement.length>200?'...':''}}</button>

          <button type="button" id="{{item.id}}"
            class="item-name font-2x text-wrapped text-left font-bold btn btn-clear p-0 btn-block mb-1"
            *ngIf="(item.item_type==='Container'.toLowerCase())" (click)="onItemClick(item)">{{item.full_statement|
            slice:0:200}}{{item.full_statement.length>200?'...':''}}</button>

          <p class="item-description font-1x mb-2" id="{{item.id}}"
            *ngIf="(item.item_type!=='Container'.toLowerCase())">
            {{item.document_title}}
          </p>
        </ng-container>

        <div
          *ngIf="dragOverId===item.id && !item.isSelected && viewType==='pacing-guide' && item.item_type==='Container'.toLowerCase() && selectedNodeId!==item.id"
          class="col-12 my-2" id="{{item.id}}"
          [ngClass]="(item.isSelected||item.id===selectedParentId)?'':item.dragStarted?'d-flex drop-zone':''">
        </div>

        <div
          *ngIf="dragOverId===item.id+'$'+item.parent_id && !item.isSelected && viewType!=='pacing-guide' && selectedNodeId!==item.id"
          class="col-12 my-2" id="{{item.id}}${{item.parent_id}}"
          [ngClass]="(item.isSelected||item.id===selectedParentId)?'':(item.dragStarted && dragOverId===item.id+'$'+item.parent_id)?'d-flex drop-zone':''">
        </div>
      </div>

      <div class="col-auto pl-0 pr-1" id="{{item.id}}"
        *ngIf="viewType==='pacing-guide' && ((item.item_type==='Container'.toLowerCase() && containerDeletePermission) || item.item_type!=='Container'.toLowerCase())">
        <div class="more-option dropdown">
          <button type="button" class="btn btn-clear" data-reference="parent" data-toggle="dropdown"
            aria-expanded="true" aria-haspopup="true">
            <em class="material-icons-outlined font-4x icon-rotate-90">
              <span aria-hidden="true">more_horiz</span>
              <span class="sr-only sr-only-focusable">more option</span>
            </em>
          </button>

          <div class="dropdown-menu dropdown-menu-right">
            <button type="button" class="btn btn-clear btn-sm px-1 py-0 dropdown-item"
              (click)="onDeleteEvent(item)">Delete</button>
          </div>

        </div>
      </div>

    </div>
    <ng-container *ngIf="item?.children && item?.expand">
      <div class="col-12 pr-0 ng-star-inserted collapse show" style="padding-left: 30px;"
        *ngIf="item.children.length > 0" id="{{ item.id }}-{{ level }}-{{ viewType }}">
        <ng-container
          *ngTemplateOutlet="recursiveList; context:{ $implicit: item.children,dragOverId:dragOverId,level:level+1 }">
        </ng-container>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: dataList,dragOverId:dragOverId,level:level }">
</ng-container>